// extracted by mini-css-extract-plugin
export default {"brandPromo":"MG-z","carousel":"NG-z"};